import { helpers } from '@vuelidate/validators';

export const alphanumericUnderscore = helpers.regex(/^[a-z0-9_]*$/);
